module.exports = __webpack_public_path__ + "fonts/3768D4_1_0.36ab14d.woff2";